import IconInfoTile from '@react/shared/components/IconInfoTile';

export default function InfoTiles() {
  return (
    <div
      className='grid grid-cols-[auto] gap-4 md:gap-6 lg:grid-cols-[var(--col4)_var(--col4)_var(--col4)]'
      data-tp-id='gen-div-8fa19afc-6978-46fb-8f47-9d3e8432eb5a'
    >
      <IconInfoTile
        layout='iconTop'
        iconBorder
        noBorder
        noPadding
        icon='Best'
        heading='100% free'
        content='Seniorly Partner Agents are commissioned by the senior living community you choose only when you move-in. They are on your side to find and choose the right option for mom or dad.'
      />
      <IconInfoTile
        layout='iconTop'
        iconBorder
        noBorder
        noPadding
        icon='Star'
        heading='Personalized Service'
        content='Navigating this process can be a challenge. Your senior living agent will help you throughout to answer questions, weigh your options, accompany you on tours and help you get the best deal for your budget.'
      />
      <IconInfoTile
        layout='iconTop'
        noBorder
        iconBorder
        noPadding
        icon='Location'
        heading='Local Insider Expertise'
        content='Your agent will know and share the unique details of assisted living communities and care options in your area.'
      />
    </div>
  );
}
